import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import RegisterAccountStep from './register/RegisterAccountStep';
import RegisterOtpStep from './register/RegisterOtpStep';
import RegisterSchoolStep from './register/RegisterSchoolStep';
import RegisterSuccess from './register/RegisterSuccess';

export default function Register() {
  return (
    <Routes>
      <Route index element={<RegisterAccountStep />} />
      <Route path="verify" element={<RegisterOtpStep />} />
      <Route path="school" element={<RegisterSchoolStep />} />
      <Route path="success" element={<RegisterSuccess />} />
      <Route path="*" element={<Navigate to="/register" replace />} />
    </Routes>
  );
}
